export const env = {
    GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    GOOGLE_CHALLENGE_URL: `${import.meta.env.VITE_IDENTITY_SERVER}/challenge-google`,
    GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,

    IDENTITY_CLIENT_ID: import.meta.env.VITE_IDENTITY_CLIENT_ID,
    IDENTITY_SERVER: import.meta.env.VITE_IDENTITY_SERVER,
    IDENTITY_CLIENT_EXTERNAL_CALLBACK_URL: `${import.meta.env.VITE_IDENTITY_CLIENT}/auth/external/callback`,

    MANAGEMENT_SERVER: import.meta.env.VITE_MANAGEMENT_SERVER,
    MANAGEMENT_SERVER_ID: import.meta.env.VITE_MANAGEMENT_SERVER_ID,
    MANAGEMENT_WEB_CLIENT_ID: import.meta.env.VITE_MANAGEMENT_WEB_CLIENT_ID,

    IDENTITY_LOGIN_PAGE: `${import.meta.env.VITE_IDENTITY_CLIENT}${import.meta.env.VITE_LOGIN_PAGE}`,
    MANAGEMENT_LOGIN_CALLBACK_PAGE: `${import.meta.env.VITE_MANAGEMENT_CLIENT}${import.meta.env.VITE_LOGIN_CALLBACK}`,
    MANAGEMENT_CLIENT_ID: import.meta.env.VITE_MANAGEMENT_CLIENT_ID,

    COUNTRY_API_SERVER: import.meta.env.VITE_COUNTRY_API_SERVER,
    COUNTRY_API_KEY: import.meta.env.VITE_COUNTRY_API_KEY
};